module.exports = __webpack_public_path__ + "static/media/chuyinshan.0c60dcdd.webp";